import type AccountPaymentInfo from "~/domains/payment/account/AccountPaymentInfo";
import type AccountProgramServiceInfo from "~/domains/payment/account/AccountProgramServiceInfo";
import type DiscountInfo from "../../../DiscountInfo";
import type { DiscountInfoType } from "../../../DiscountInfoType";
import type ProgramServiceDiscountStrategy from "./ProgramServiceDiscountStrategy";
import _ from "lodash";
import { roundPrice, isAccountProgramLawnCare } from "~/utils/payment";

export default class PrePayProgramServiceDiscountStrategy implements ProgramServiceDiscountStrategy {
  getDiscountInfoType(): DiscountInfoType {
    return "prePay";
  }

  getDiscountInfo(accountProgramServiceInfo: AccountProgramServiceInfo, accountPaymentInfo: AccountPaymentInfo, currentSubtotal: number): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "prePay",
      description: "",
      value: 0,
      amount: 0,
    };

    /* Pre-Pay Discount only applies if:
      - Customer is not on an installment plan
      - Customer is paying now
      - No services have been completed in the current year
      - This program/service is not monthly
      - The service belongs to a lawn care program
     */
    if (accountPaymentInfo.payType === "autoPayInstallment") {
      return discountInfo;
    }

    // Pre-Pay discount only applies to lawn care services.
    const parentProgram = accountPaymentInfo.programs.find((program) => program.id === accountProgramServiceInfo.programID);
    if (!parentProgram || !isAccountProgramLawnCare(parentProgram, accountPaymentInfo.programCodes, accountPaymentInfo.franchiseServices)) {
      return discountInfo;
    }

    if (
      accountPaymentInfo.payType === "payNow"
      && _.sum(accountPaymentInfo.programs.map((program) => program.doneToDate ?? 0)) === 0
    ) {
      const existingCustomerPrePayDiscount = accountPaymentInfo.franchiseDiscounts.find((franchiseDiscount) => franchiseDiscount.name === "ExistingCustomerPrePayDiscount");
      const prePayDiscount = accountPaymentInfo.franchiseDiscounts.find((franchiseDiscount) => franchiseDiscount.name === "PrePayDiscount");
      const prePayDiscountValue = existingCustomerPrePayDiscount?.value ?? prePayDiscount?.value ?? 0;
      const prePayDiscountAmount = currentSubtotal * prePayDiscountValue;

      discountInfo.description = `Pre-Pay Discount (${Math.round(prePayDiscountValue * 100)}%)`;
      discountInfo.value = prePayDiscountValue;
      discountInfo.amount = roundPrice(prePayDiscountAmount, "nearest", 2);
    }

    return discountInfo;
  }
}
